import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { PyramidIcon, AtomIcon, EyeIcon } from 'lucide-react';
export function TrustPillars() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="py-16 md:py-24" data-id="element-790">
      <div className="max-w-5xl mx-auto px-6" data-id="element-791">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-792">
          {/* Pillar 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0
        }} className="p-6 md:p-8 rounded-2xl bg-neutral-900/50 border border-teal-500/10 text-center" data-id="element-793">
            <div className="w-12 h-12 rounded-xl bg-teal-500/10 flex items-center justify-center mx-auto mb-5" data-id="element-794">
              <PyramidIcon className="w-6 h-6 text-teal-400" data-id="element-795" />
            </div>
            <h3 className="font-serif text-xl font-bold text-white mb-3" data-id="element-796">
              5,000 Years of Hidden Wisdom
            </h3>
            <p className="text-neutral-400 text-sm leading-relaxed" data-id="element-797">
              Ancient systems encoded the rules of the game in symbols, geometry
              and myth
            </p>
          </motion.div>

          {/* Pillar 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="p-6 md:p-8 rounded-2xl bg-neutral-900/50 border border-teal-500/10 text-center" data-id="element-798">
            <div className="w-12 h-12 rounded-xl bg-teal-500/10 flex items-center justify-center mx-auto mb-5" data-id="element-799">
              <AtomIcon className="w-6 h-6 text-teal-400" data-id="element-800" />
            </div>
            <h3 className="font-serif text-xl font-bold text-white mb-3" data-id="element-801">
              Quantum Science Validates It
            </h3>
            <p className="text-neutral-400 text-sm leading-relaxed" data-id="element-802">
              Physics confirms what mystics always knew about consciousness and
              reality
            </p>
          </motion.div>

          {/* Pillar 3 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="p-6 md:p-8 rounded-2xl bg-neutral-900/50 border border-teal-500/10 text-center" data-id="element-803">
            <div className="w-12 h-12 rounded-xl bg-teal-500/10 flex items-center justify-center mx-auto mb-5" data-id="element-804">
              <EyeIcon className="w-6 h-6 text-teal-400" data-id="element-805" />
            </div>
            <h3 className="font-serif text-xl font-bold text-white mb-3" data-id="element-806">
              You Already Know This Is True
            </h3>
            <p className="text-neutral-400 text-sm leading-relaxed" data-id="element-807">
              The feeling that something is off has always been correct
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}